


















































































import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'
import { RepasseProjecao } from '@/types/interfaces/RepasseProjecao'
import { formatValorBRL } from '@/utils/formatacaoNumerica'
import { formatRepasseDate, getCustoAntecipacao } from '../antecipacao/repasseProjecao'

@Component({ name: 'ModalResumoAntecipacao' })
export default class ModalResumoAntecipacao extends Vue {
  @Prop({ type: Boolean, default: false }) visible: boolean
  @Prop({ type: String, default: '' }) hospitalNome: string
  @Prop({ type: String, default: '' }) empresaMedicaNome: string
  @Prop({ type: Number, required: true }) valorSolicitado: number
  @Prop({ type: Object, default: null }) repasseFinal: RepasseProjecao | null
  @Prop({ type: Boolean, default: false }) confirmando: boolean

  get valorSolicitadoFormatado(): string {
    return formatValorBRL(this.valorSolicitado)
  }

  get dataRepasseFinal(): string {
    return this.repasseFinal ? formatRepasseDate(this.repasseFinal.data) : ''
  }

  get custoRepasseFinal(): string {
    return this.repasseFinal ? formatValorBRL(getCustoAntecipacao(this.repasseFinal, this.valorSolicitado)) : ''
  }

  get descontoRepasseFinal(): string {
    return this.repasseFinal ? formatValorBRL(this.repasseFinal.desconto) : ''
  }

  @Emit('close')
  close() {}

  @Emit('confirmar')
  confirmar() {}
}
